import s from "./progressBar.module.css";

const ProgressBar = (props) => {
    // Destructured props
    let {
        currentSlide,
        handleCurrentSlide,
        centered = false,
        TOTAL_SLIDES = 4,
        hideItems = false
    } = props;

    // Simple adapter for the slide counter to count from 1 at the second slide
    currentSlide = currentSlide - 1;

    const slidesArray = Array.from(Array(TOTAL_SLIDES + 1).keys());
    // Purposefully removes the first element of the array ("0")
    slidesArray.shift();

    // TODO: I'm not quite sure if this is really necessary,
    //  but it's the best way I found to adapt this feature to mobile devices,
    //  as at the desktop it must be divided in two sections (top and bottom).
    const arrayClone = [...slidesArray];

    // For tablet and desktop viewports
    const topSection = slidesArray.splice(0, currentSlide);
    const bottomSection = [...slidesArray];

    const topBullets =
        topSection.map((item, index) => (
            <button
                key={item}
                type="button"
                className={`${s.bullet} ${currentSlide === item ? s.active : ""}`}
                style={{
                    zIndex: index + 1,
                    top: currentSlide === item ? "30px" : `-${10 * index}px`,
                }}
                // onClick={() => handleCurrentSlide(item + 1)}
            >
                {item}
            </button>
        ));

    const bottomBullets =
        bottomSection.map((item, index) => (
            <button
                key={item}
                type="button"
                className={`${s.bullet}`}
                style={{
                    zIndex: bottomSection.length - index,
                    bottom: `-${10 * (bottomSection.length - (index + 1))}px`,
                }}
                onClick={() => handleCurrentSlide()}
            >
                {item}
            </button>
        ));

    const mobileBullets =
        arrayClone.map((item, index) => (
            <button
                key={item}
                type="button"
                className={`${s.bullet} ${currentSlide === item ? s.active : ""}`}
                onClick={() => handleCurrentSlide()}
            >
                {item}
            </button>
        ));

    return (
        <div className={`${s.root} text-white`}>
            <div className={`${s.topSection} ${centered ? s.centeredTopSection : ""} ${hideItems ? "opacity-0 pointer-events-none" : "opacity-100"}`}>
                {topBullets}
            </div>
            <div className={`${s.bottomSection} ${hideItems ? "opacity-0 pointer-events-none" : "opacity-100"}`}>
                {bottomBullets}
            </div>
            <div className={`${s.mobileSection} ${hideItems ? "opacity-0 pointer-events-none" : "opacity-100"}`}>
                {mobileBullets}
            </div>
        </div>
    )
}

export default ProgressBar;
